import { Link } from "react-router-dom";
import { photobooks } from "@/mocks/photobooks";

export default function PhotobookRow() {
  return (
    <div className="flex gap-4 overflow-x-auto pb-2 no-scrollbar">
      {photobooks.map((book) => (
        <Link
          key={book.id}
          to={`/photobooks/detail/${book.id}`}
          className="group w-56 shrink-0 overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300 md:w-64"
        >
          <div className="relative h-72 w-full overflow-hidden md:h-80">
            <img
              src={book.cover}
              alt={book.title}
              title={`${book.title} - 美女写真集`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-0.5 text-[11px] font-medium text-primary-700">
              {book.theme}
            </span>
            <span className="absolute bottom-3 right-3 rounded-full bg-black/55 px-2 py-0.5 text-[11px] text-white">
              {book.count} 张
            </span>
          </div>
          <div className="p-4">
            <h3 className="font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-600">
              {book.title}
            </h3>
            <p className="mt-1.5 line-clamp-2 text-xs leading-5 text-foreground-600">
              {book.description}
            </p>
            <div className="mt-3 flex items-center justify-between text-[11px] text-foreground-500">
              <span className="flex items-center gap-1">
                <i className="ri-user-line"></i>
                {book.author}
              </span>
              <span>{book.date}</span>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}